<template>
  <div class="top-baner-image">
    <img
      :src="`${staticUrl}/images/vector_galery.webp`"
      loading="lazy"
      alt=""
      class="second-image header-image"
    />
    <img
      :src="`${staticUrl}/images/Vector_214.webp`"
      loading="lazy"
      alt=""
      class="first-image header-image"
    />
  </div>
</template>
<script setup lang="ts">
import {useRuntimeConfig} from '#imports';
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
</script>
<style lang="scss" scoped>
.top-baner-image {
  .header-image {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 500px;
    background-size: contain !important;
  }
}
</style>
